<template>
  <div class="cutting-preview">
    <up-preview
      class="cutting-preview__preview"
      width="90%"
      v-model="preview.visible"
      :initial-index="preview.activeIndex"
      :active-index="preview.activeIndex"
      :data="preview.data"
    >
      <template slot-scope="{ item }">
        <img v-if="isPicture" class="cutting-preview__preview-image" :src="item.path" />
        <video v-if="isVideo" class="cutting-preview__preview-image" :src="item.path" controls />
      </template>
    </up-preview>
    <up-dialog v-model="visible" :has-footer="false" width="90%">
      <div class="cutting-preview__screen-image is-preview" :style="previewScreenStyle" v-if="cutted">
        <div class="cutting-preview__screen-cutted">
          <img :src="cutted.path" />
        </div>
        <div class="cutting-preview__screen-logo" :style="{ height: `${cutted.logoHeight}px` }">
          <img :src="cutted.bottom_logo" />
        </div>
      </div>
    </up-dialog>
    <panel-head title="广告裁切预览" subtitle="AD CUT PREVIEW" :export-url="exportUrl"></panel-head>
    <div class="panel-content">
      <el-form v-loading="loading"
        element-loading-text="加载中..."
        :model="form"
        :rules="rules"
        ref="form"
        class="panel-content__form"
        label-width="120px">
        <up-form-item-select
          required
          filterable
          label="广告位"
          prop="place"
          v-model="form.place"
          :data="places"
          @up:select:change="handlePlaceChange"
        ></up-form-item-select>
        <up-form-item-radio
          required
          prop="create_type"
          label="素材类型"
          v-model="form.create_type"
          :data="createTypes"
          placeholder="请选择素材类型"
        ></up-form-item-radio>
        <up-form-item label="素材尺寸">
          <up-radio-group
            :disabled="true"
            v-model="form.material_size"
            :data="[{ name: '固定尺寸上传', value: '0' }, { name: '按比例上传', value: '1' }]"
          ></up-radio-group>
          <div>
            <ul
              class="cutting-preview__material-size clearfix"
              v-if="form.material_size === '0' && materialSize.sizes.length">
              <li
                v-for="item in materialSize.sizes"
                :key="item.size_id"
                :class="{ 'is-active': materialSize.matched.indexOf(item.size) > -1 }">
                {{ item.size }}
              </li>
            </ul>
          </div>
        </up-form-item>
        <div class="cutting-preview__group">
          <div class="cutting-preview__list">
            <div class="cutting-preview__item" v-for="(material, index) in form.materials" :key="index">
              <up-form-item
                label="素材上传"
                :prop="`materials.${index}.files`"
                :rules="{ type: 'array', required: true, min: 1, message: '请上传素材', trigger: 'change' }"
              >
                <up-upload
                  multiple
                  action="whatever"
                  :file-list="material.fileList"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => handleOnChange(file, fileList, index)"
                >
                  <up-button size="large" type="primary">
                    批量上传{{ form.create_type === '2' ? '视频' : '图片' }}
                    <i
                      class="el-icon-upload el-icon--right"
                    ></i>
                  </up-button>
                  <div slot="tip" class="cutting-preview__upload-tip">{{ uploadTipText }}</div>
                </up-upload>
                <up-table
                  class="cutting-preview__table"
                  border
                  align="center"
                  :page="material.page"
                  :width-columns="{ preview: '300px', size: '100px', code: '100px' }"
                  :slotContents="['preview', 'path', 'match']"
                  @cell-click="(row, column) => handleCellClick({ row, column }, index)"
                >
                  <template slot="preview:content" slot-scope="{ row }">
                    <img v-if="isPicture" class="is-preview" :src="row.preview" />
                    <video v-if="isVideo" class="is-preview" :src="row.preview"></video>
                  </template>
                  <template slot="path:content" slot-scope="{ row }">
                    <a class="is-path" :href="row.path" target="_blank">{{ row.path }}</a>
                  </template>
                  <template slot="match:content" slot-scope="{ row }">
                    <span
                      class="icon iconfont"
                      :class="`${row.match ? 'icon-right': 'icon-wrong'}`"
                    ></span>
                  </template>
                  <template slot="up:operate">
                    <up-table-column label="操作">
                      <template slot-scope="scope">
                        <up-upload
                          class="cutting-preview__replace"
                          action="whatever"
                          :auto-upload="false"
                          :show-file-list="false"
                          :on-change="(file, fileList) => handleOnChange(file, fileList, index, scope)"
                          :disabled="material.replacing[scope.$index]"
                        >
                          <up-button size="small" type="primary">
                            替换
                            <i
                              v-if="material.replacing[scope.$index]"
                              class="el-icon el-icon-loading"
                            ></i>
                          </up-button>
                        </up-upload>
                        <up-popover
                          placement="top"
                          width="160"
                          v-model="material.visibles[scope.$index]"
                          hasFooter
                          @up:confirm="handleRemoveMaterial(index, scope)"
                        >
                          <p>确定要删除该素材吗？</p>
                          <up-button
                            slot="reference"
                            size="small"
                            class="is-remove ml5"
                            type="primary"
                          >
                            删除
                            <i
                              v-if="material.removing[scope.$index]"
                              class="el-icon el-icon-loading"
                            ></i>
                          </up-button>
                        </up-popover>
                      </template>
                    </up-table-column>
                  </template>
                </up-table>
              </up-form-item>
            </div>
          </div>
        </div>
        <div class="panel-content__btn-group">
          <up-button :disabled="disabledBtn || submiting" size="large" type="primary" @click="submitForm('form')">{{ btnText('完成') }}</up-button>
        </div>
      </el-form>
    </div>
    <div class="panel-header pt20">
      <h3 class="panel-header__title">各屏幕展示效果预览</h3>
    </div>
    <div class="panel-content">
      <div class="panel-content__select-list">
        <up-select class="fl is-small" :data="cuttingSizes" v-model="cuttingSize" @change="handleCuttingSizeChange"></up-select>
      </div>
      <div class="cutting-preview__screen-list">
        <div class="cutting-preview__screen-item">
          <template v-if="cutted && !cutting && finished">
            <div class="cutting-preview__screen-image" :class="{ 'is-active': !!cutted }"  :style="screenStyle" @click="visible = true">
              <div class="cutting-preview__screen-cutted">
                <img :src="cutted.path" />
              </div>
              <div class="cutting-preview__screen-logo" :style="{ height: `${cutted.logoHeight}px` }">
                <img :src="cutted.bottom_logo" />
              </div>
            </div>
            <div class="cutting-preview__screen-desc">
              <p>屏幕尺寸：{{ cuttingSize }}</p>
              <p>流量占比：{{ curttingRatio }}%</p>
              <p>原素材尺寸：{{ cutted.width }}*{{ cutted.height }}</p>
            </div>
          </template>
          <p v-else-if="cutting">裁切中...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PanelHead } from '@/global/components'
import { capturedGet, capturedPost } from '@/manager/http'
import { groupBy } from '@/global/util/util'

const CONTAINER_WIDTH = 180
const PREVIEW_CONTAINER_WIDTH = 1080

export default {
  name: 'cutting-preview',
  components: { PanelHead },
  data () {
    return {
      platform: '',
      exportUrl: '',
      loading: false,
      form: {
        place: '',
        create_type: '1',
        material_size: '0',
        materials: [{
          title: '',
          spread_name: '',
          fileList: [],
          replaceList: [],
          page: new this.$page({
            header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
          }),
          files: [],
          replacing: [],
          removing: [],
          visibles: [], // 删除素材组中的素材标识
          visible: false // 删除素材组标识
        }]
      },
      rules: {
        place: [{ required: true, message: '请选择广告位', trigger: 'change' }]
      },
      places: [],
      placeSizes: [],
      createTypes: [],
      cuttingSizes: [],
      cuttingSize: '',
      cutted: null,
      cutting: false,
      finished: false,
      materialSize: {
        sizes: [],
        matched: []
      },
      submiting: false,
      preview: { // 预览
        visible: false,
        activeIndex: -1,
        data: []
      },
      visible: false
    }
  },
  computed: {
    curttingRatio () {
      if (!this.cuttingSize) return ''
      const [screenWidth, screenHeight] = this.cuttingSize.split('*')
      const cuttingSize = this.cuttingSizes.find(v => v.width === parseInt(screenWidth, 10) && v.height === parseInt(screenHeight, 10))
      return cuttingSize ? cuttingSize.ratio : '0'
    },
    screenStyle () {
      if (!this.cuttingSize) return { height: '300px' }
      const [screenWidth, screenHeight] = this.cuttingSize.split('*')
      return { width: `${CONTAINER_WIDTH}px`, height: `${CONTAINER_WIDTH / (screenWidth / screenHeight)}px` }
    },
    previewScreenStyle () {
      if (!this.cuttingSize) return { height: '300px' }
      const [screenWidth, screenHeight] = this.cuttingSize.split('*')
      return { width: `${PREVIEW_CONTAINER_WIDTH}px`, height: `${PREVIEW_CONTAINER_WIDTH / (screenWidth / screenHeight)}px` }
    },
    btnText () {
      return function (text) {
        return this.submiting ? `${text}中...` : text
      }
    },
    isPicture () {
      return this.form.create_type === '1'
    },
    isVideo () {
      return this.form.create_type === '2'
    },
    disabledBtn () {
      return !this.cuttingSize || this.form.materials.some((material) => {
        return material.page.data.length === 0 || material.page.data.some(item => !item.match)
      })
    },
    uploadTipText () {
      let text
      if (this.isM) { // 小米
        text = '小米渠道仅允许上传jpg格式文件，小图、组图不超过100K，大图不超过500K'
      } else if (this.isZ) { // 掌阅
        text = '支持上传 jpg/jpeg/png/gif 格式文件，且不超过150KB'
      } else {
        text = '支持上传 jpg/jpeg/png 格式文件，不超过150K；gif 格式文件，不超过2M'
      }

      return this.isPicture ? text : '只支持上传 mp4 格式文件，且不超过3M'
    }
  },
  async created () {
    this.platform = this.$route.meta.platform
    this.loading = true

    await Promise.all([
      this.getPlaces(),
      this.getPlaceSize(),
      this.getCuttingSizes()
    ])

    this.loading = false
  },
  methods: {
    async submitForm (form) {
      this.submiting = true
      await this.handleCuttingSizeChange(this.cuttingSize)
      this.submiting = false
      this.finished = true
    },
    async handleCuttingSizeChange (value) {
      const pictureList = this.form.materials.reduce((prev, cur) => {
        return prev.concat(cur.page.data.map(({ size, path }) => {
          const [width, height] = size.split('*')
          return {
            width,
            height,
            path
          }
        }))
      }, [])
      if (!pictureList.length) return

      this.cutting = true
      const [width, height] = value.split('*')

      const [err, res] = await capturedPost('/v2/tailor', {
        width,
        height,
        pictureList
      })
      if (err || res.code !== 1) {
        this.$message.error((err || res).msg || '裁切失败')
      } else {
        this.cutted = res.data
        this.cutted.logoHeight = parseInt(this.screenStyle.height) * parseInt(res.data.bottom_ratio) / 100
        this.$message.success(res.msg || '裁切成功')
      }
      this.cutting = false
    },
    handleCellClick ({ row, column }, index) {
      if (column.property === 'preview') {
        const data = this.form.materials[index].page.data
        this.preview.visible = true
        this.preview.activeIndex = data.indexOf(row)
        this.preview.data = data
      }
    },
    async uploadPicture (file) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('information', this.form.information || '0')
      return await capturedPost(`/${this.platform}/ads/ad/upload`, formData, { 'Content-Type': 'multipart/form-data' })
    },
    async uploadVideo (file) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('place', this.placeId)
      formData.append('information', this.form.information || '0')
      return await capturedPost(`/${this.platform}/ads/ad/upload-video`, formData, { 'Content-Type': 'multipart/form-data' })
    },
    // 上传素材
    async handleOnChange (file, fileList, index, scope) {
      if (!this.form.place) {
        this.$message.error('请先选择广告位！')
        return this.$refs.form.validateField('place')
      }

      if (scope) {
        if (this.form.materials[index].replacing[scope.$index]) return
        this.form.materials[index].replacing.splice(scope.$index, 1, true)
      }

      if (this.isPicture && !this.beforeUploadPictureMaterial(file)) return
      if (this.isVideo && !this.beforeUploadVideoMaterail(file)) return

      let material
      let [ matched, matchedSize ] = []
      let { path, size, seconds, fileSize } = {}

      if (this.isPicture) {
        const [err, res] = await this.uploadPicture(file)
        if (scope) this.form.materials[index].replacing.splice(scope.$index, 1, false)
        if (err || res.code !== 1) this.$message.error((err || res).msg || '上传图片素材失败！')
        else {
          ({ path, size } = res.data)
          ;[ matched, matchedSize ] = this.isMatch(size)
          if (matched && (!scope || !scope.row.match) && !this.validateMaterial(this.form.materials[index].page.data, size)) return

          material = { preview: path, path, size, match: matched }
        }
      } else if (this.isVideo) {
        const [err, res] = await this.uploadVideo(file)
        if (scope) this.form.materials[index].replacing.splice(scope.$index, 1, false)
        if (err || res.code !== 1) this.$message.error((err || res).msg || '上传视频素材失败！')
        else {
          ({ path, size, seconds, file_size: fileSize } = res.data)
          ;[ matched, matchedSize ] = this.isMatch(size)
          if (seconds > 5) { return this.$message.error('视频素材时长不能超过5秒') }
          if (matched && (!scope || !scope.row.match) && !this.validateMaterial(this.form.materials[index].page.data, size)) return

          material = { preview: path, path, size, match: matched, seconds, file_size: fileSize }
        }
      }

      if (!scope) {
        this.form.materials[index].visibles.push(false)
        this.form.materials[index].replacing.push(false)
        this.form.materials[index].removing.push(false)
        this.form.materials[index].page.data.push(material)
      } else {
        material.id = scope.row.id
        this.form.materials[index].page.data.splice(scope.$index, 1, material)
        if (scope.row.match) {
          this.form.materials[index].files = this.form.materials[index].files.filter(v => v.path !== scope.row.path)
        }
      }

      if (this.isPicture) {
        !scope ? this.$message.success('上传图片素材成功！') : this.$message.success('替换图片素材成功！')
      } else if (this.isVideo) {
        !scope ? this.$message.success('上传视频素材成功！') : this.$message.success('替换视频素材成功！')
      }

      if (matched) {
        const item = {
          path,
          id: material.id,
          size,
          size_id: matchedSize.size_id,
          code: '1'
        }

        if (this.isVideo) {
          item.seconds = seconds
          item.file_size = fileSize
        }

        this.form.materials[index].files.push(item)
      }
      this.$refs.form.validateField(`materials.${index}.files`)

      // 更新素材尺寸状态
      this.updateMaterialSizeStatus()
    },
    // 删除素材
    async handleRemoveMaterial (index, scope) {
      if (scope && this.form.materials[index].removing[scope.$index]) return

      let ids = []
      if (scope && scope.row.id) {
        ids.push(scope.row.id)
      } else {
        ids = this.form.materials[index].page.data.reduce((prev, cur) => {
          if (cur.id) {
            prev.push(cur.id)
          }
          return prev
        }, [])
      }

      if (ids.length > 0) {
        if (scope) this.form.materials[index].removing.splice(scope.$index, 1, true)
        const [err, res] = await capturedGet(`/${this.platform}/ads/ad/delplacematerials`, { ids: ids.join(',') })
        if (scope) this.form.materials[index].removing.splice(scope.$index, 1, false)
        if (err || res.code !== 1) return this.$message.error((err || res).msg || '删除素材失败！')
      }

      if (scope) {
        this.form.materials[index].visibles.splice(scope.$index, 1)
        this.form.materials[index].replacing.splice(scope.$index, 1)
        this.form.materials[index].removing.splice(scope.$index, 1)
        this.form.materials[index].page.data.splice(scope.$index, 1)

        if (scope.row.match) { // 过滤 files
          this.form.materials[index].files = this.form.materials[index].files.filter(v => v.path !== scope.row.path)
        }
      } else {
        this.form.materials.splice(index, 1)
      }
      this.$message.success('删除素材成功！')
      // 更新素材尺寸选中状态
      this.updateMaterialSizeStatus()
    },
    // 更新素材尺寸匹配状态
    updateMaterialSizeStatus () {
      this.materialSize.matched = this.form.materials.reduce((prev, cur) => {
        for (let item of cur.page.data) {
          if (!prev.includes(item.size) && this.isMatch(item.size)[0]) {
            prev.push(item.size)
          }
        }
        return prev
      }, [])
    },
    validateMaterial (data, size) {
      const groupedData = groupBy(data.filter(v => v.match), 'size') // 分组后匹配的素材
      const groupedSizes = Object.keys(groupedData)
      if (groupedSizes.length === 0) return true

      if (groupedSizes.includes(size) && groupedData[size].length === 1) {
        this.$message.error(this.isPicture ? '每个尺寸只能上传一张图片素材！' : '每个尺寸只能上传一个视频素材！')
        return false
      }
      return true
    },
    isMatch (size) {
      size = this.materialSize.sizes.find(v => v.size === size)
      return [!!size, size]
    },
    beforeUploadPictureMaterial (file) {
      const { type, size } = file.raw
      const isSupport = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'].includes(type)
      const isGIF = type === 'image/gif'
      const isJPG = ['image/jpeg', 'image/jpg'].includes(type)
      const isLt100KB = size / 1024 < 100; // 小米 jpg
      const isLt500KB = size / 1024 < 500; // 小米 jpg
      const isLt150KB = size / 1024 < 150; // 掌阅 gif
      const isLt2M = size / 1024 / 1024 < 2;
      const isLarge = this.form.information === '3' // 大图

      // if (this.isM) { // 小米
      //   text = '小米渠道仅允许上传jpg格式文件，小图、组图不超过100K，大图不超过500K'
      // } else if (this.isZ) { // 掌阅
      //   text = '支持上传 jpg/jpeg/png/gif 格式文件，且不超过150KB'
      // } else {
      //   text = '支持上传 jpg/jpeg/png 格式文件，不超过150K；gif 格式文件，不超过2M'
      // }

      if (this.isM) { // 小米
        if (!isJPG) {
          this.$message.error('小米渠道图片素材只能是 jpg 格式！')
        } else {
          if (isLarge && !isLt500KB) {
            this.$message.error('小米渠道大图图片素材大小不能超过 500k！')
          } else if (!isLarge && !isLt100KB) {
            this.$message.error('小米渠道小图、组图图片素材大小不能超过 100k！')
          }
        }
      } else {
        if (!isSupport) {
          this.$message.error('图片素材只能是 png, jpg, jpeg, gif 格式！');
        }
        if (!isLt150KB && (this.isZ || !isGIF)) {
          this.$message.error('图片素材大小不能超过 150KB！');
        }
        if (!this.isZ && isGIF && !isLt2M) {
          this.$message.error('图片素材大小不能超过 2M！');
        }
      }

      return this.isM ? isJPG && ((isLarge && isLt500KB) || (!isLarge && isLt100KB))
        : isSupport && (((this.isZ || !isGIF) && isLt150KB) || (!this.isZ && isGIF && isLt2M))
    },
    beforeUploadVideoMaterail (file) {
      const isSupport = ['video/mp4'].includes(file.raw.type);
      const isLt3M = file.raw.size / 1024 / 1024 <= 3;

      if (!isSupport) {
        this.$message.error('视频素材只能是 mp4 格式！');
      }

      if (!isLt3M) {
        this.$message.error('视频素材大小不能超过 3MB！');
      }

      return isSupport && isLt3M;
    },
    async getPlaces () {
      const [err, res] = await capturedGet('/v2/tailorPlace')
      if (err || res.code !== 1) {
        this.message.error((err || res).msg || '获取广告位失败')
      } else {
        this.places = res.code === 1 ? res.data : []
      }
    },
    async getCreateTypes (placeId) {
      const [err, res] = await capturedGet('/interface/place/attribute/create_type', { place: placeId })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取素材类型失败！')
      else {
        this.createTypes = res.code === 1 ? res.data.map(v => ({ ...v, disabled: v.value === '2' })) : []
      }
    },
    async getPlaceSize () {
      const [err, res] = await capturedGet('/v2/placeSize')
      if (err || res.code !== 1) {
        this.message.error((err || res).msg || '获取广告位尺寸失败')
      } else {
        this.materialSize.sizes = res.code === 1 ? res.data.map(v => ({
          ...v,
          size: `${v.width}*${v.height}`
        })) : []
      }
    },
    async getCuttingSizes () {
      const [err, res] = await capturedGet('/v2/tailorSize')
      if (err || res.code !== 1) {
        this.message.error((err || res).msg || '获取裁切尺寸失败')
      } else {
        this.cuttingSizes = res.code === 1 ? res.data.map(({ width, height, ratio }) => ({
          name: `${width}*${height}`,
          value: `${width}*${height}`,
          width,
          height,
          ratio
        })) : []
        this.cuttingSize = this.cuttingSizes[0].value
      }
    },
    handlePlaceChange (value) {
      this.getCreateTypes(value)
    }
  }
}
</script>

<style lang="scss">
@include b(cutting-preview) {
  @include e(preview) {
    .el-carousel__container {
      height: 420px;
    }
  }

  @include e(preview-image) {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  @include e(material-size) {
    margin-left: 16px;

    li {
      float: left;
      height: 30px;
      margin-right: 10px;
      padding: 0 10px;
      font-size: 14px;
      line-height: 30px;

      @include is(active) {
        color: #fff;
        background-color: #495b6c;
      }
    }
  }

  @include e(upload-tip) {
    margin-left: 16px;
    font-size: 12px;
    color: #fc8675;
  }

  @include e(table) {
    margin-top: 16px;
    margin-left: 16px;

    .icon-right {
      color: #66cfa7;
    }

    .icon-wrong {
      color: #fc8675;
    }

    .is-path {
      text-decoration: underline;
      color: #1c8de0;
    }

    .is-preview {
      max-width: 100%;
      max-height: 100px;
      margin: 0 auto;
    }
  }

  @include e(replace) {
    display: inline-block;
  }

  @include e(group) {
    margin-bottom: 22px;
  }

  @include e(list) {
    padding: 10px 0;
    // border: 1px solid #3dc1c4;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  @include e(screen-list) {
    padding: 30px 0 0 20px;
  }

  @include e(screen-item) {
    min-height: 400px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  @include e(screen-image) {
    display: flex;
    flex-direction: column;

    @include is(active) {
      // box-shadow: -6px 8px 17px 6px rgba(108, 108, 108, 0.3);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04)
    }

    @include is(preview) {
      margin: 0 auto;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  @include e(screen-cutted) {
    flex: 85;
  }

  @include e(screen-logo) {
    flex: 15;
  }

  @include e(screen-desc) {
    margin-top: 20px;

    p {
      line-height: 16px;
    }
  }
}
</style>
